import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Package, ShoppingBag, TrendingUp, Percent, IndianRupee, ArrowRight } from "lucide-react";

export default function VendorDashboard() {
  const [stats, setStats] = useState(null);
  const [vendor, setVendor] = useState(null);

  useEffect(() => {
    Promise.all([api.get("/vendor/stats"), api.get("/vendor/me")]).then(([s, v]) => {
      setStats(s.data);
      setVendor(v.data);
    });
  }, []);

  if (!stats || !vendor) return <div className="p-10 text-center text-[#3B5249]">Loading…</div>;

  if (vendor.status !== "approved") {
    return (
      <div className="max-w-3xl mx-auto px-4 py-16 text-center">
        <h1 className="font-display text-3xl text-[#0F3D2E]">Application under review</h1>
        <p className="mt-3 text-[#3B5249]">Your vendor application status: <b className="capitalize">{vendor.status}</b>. You'll be able to list products once approved.</p>
        <Link to="/sell"><button className="mt-6 px-6 py-2 rounded-full bg-[#0F3D2E] text-white">View Application</button></Link>
      </div>
    );
  }

  const cards = [
    { icon: IndianRupee, label: "Gross Sales", value: `₹${stats.gross_sales.toLocaleString()}`, color: "text-[#14A085]" },
    { icon: Percent, label: "Commission (1%)", value: `₹${stats.commission.toLocaleString()}`, color: "text-amber-600" },
    { icon: TrendingUp, label: "Net Payable", value: `₹${stats.net_payable.toLocaleString()}`, color: "text-[#0F3D2E]" },
    { icon: ShoppingBag, label: "Orders", value: stats.orders_total, color: "text-[#0F3D2E]" },
    { icon: Package, label: "Products Listed", value: stats.products, color: "text-[#0F3D2E]" },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#14A085]">Vendor</div>
          <h1 className="font-display text-3xl md:text-4xl text-[#0F3D2E]">{vendor.business_name}</h1>
          <p className="text-sm text-[#3B5249] mt-1">Welcome back — here's how your store is doing.</p>
        </div>
        <div className="flex gap-2">
          <Link to="/vendor/products" data-testid="link-vendor-products"><button className="h-10 px-4 rounded-full bg-[#0F3D2E] text-white hover:bg-[#14A085]">Manage Products</button></Link>
          <Link to="/vendor/orders" data-testid="link-vendor-orders"><button className="h-10 px-4 rounded-full border border-[#0F3D2E] text-[#0F3D2E] hover:bg-[#E8F5F2]">View Orders</button></Link>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4" data-testid="vendor-stats">
        {cards.map((c, i) => (
          <div key={i} className="rounded-xl border border-[#E2E8E5] bg-white p-5">
            <c.icon className={c.color} size={20} />
            <div className="mt-2 text-xs text-[#6E877C] uppercase tracking-widest">{c.label}</div>
            <div className="mt-1 font-display text-2xl text-[#0F3D2E]" data-testid={`stat-${i}`}>{c.value}</div>
          </div>
        ))}
      </div>

      <div className="mt-8 grid md:grid-cols-2 gap-4">
        <Link to="/vendor/products" className="card-hover rounded-xl border border-[#E2E8E5] bg-white p-6 flex items-center justify-between">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-[#14A085]">Catalog</div>
            <div className="font-display text-2xl text-[#0F3D2E] mt-1">Add & manage products</div>
            <div className="text-sm text-[#3B5249] mt-1">Upload products, set price, stock and images.</div>
          </div>
          <ArrowRight className="text-[#14A085]" />
        </Link>
        <Link to="/vendor/orders" className="card-hover rounded-xl border border-[#E2E8E5] bg-white p-6 flex items-center justify-between">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-[#14A085]">Fulfillment</div>
            <div className="font-display text-2xl text-[#0F3D2E] mt-1">Process incoming orders</div>
            <div className="text-sm text-[#3B5249] mt-1">Accept, pack and ship. Update status per line item.</div>
          </div>
          <ArrowRight className="text-[#14A085]" />
        </Link>
      </div>
    </div>
  );
}
